import React, { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "../../Styles/quillCustom.scss";

interface RichTextInputProps {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  readOnly?: boolean;
  height?: number | string;
  showCount?: boolean;
}

const RichTextInput: React.FC<RichTextInputProps> = ({
  value,
  onChange,
  maxLength = 50000,
  readOnly = false,
  height,
  showCount = true,
}) => {
  const [charCount, setCharCount] = useState(0);

  const stripExcelCss = (html: string) => html.replace(/^<p>[\s\S]*?(mso-|\.xl\d+|table\s*\{)[\s\S]*?<\/p>/i, "");

  const handleChange = (_event: any, editor: any) => {
    let data = editor.getData();
    data = stripExcelCss(data);
    const text = data.replace(/<(.|\n)*?>/g, "").trim();
    const length = text.length;

    if (length <= maxLength) {
      setCharCount(length);
      onChange(data);
    }
  };

  return (
    <>
      <CKEditor
        editor={ClassicEditor}
        data={value}
        disabled={readOnly}
        onChange={handleChange}
        config={
          {
            licenseKey: "GPL",

            htmlSupport: {
              disallow: [{ attributes: ["style"] }],
            },

            toolbar: readOnly
              ? []
              : ["bold", "italic", "underline", "bulletedList", "numberedList", "link", "insertTable", "undo", "redo"],

            table: {
              contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
            },
          } as any
        }
      />

      {showCount && (
        <div
          style={{
            textAlign: "right",
            fontSize: 12,
            marginTop: 4,
            color: charCount >= maxLength ? "red" : "gray",
          }}
        >
          {charCount}/{maxLength}
        </div>
      )}
    </>
  );
};

export default RichTextInput;
